/**
 * Route Guard — Protects authenticated pages
 *
 * Redirects unauthenticated users to the Login page
 * instead of letting them access restricted routes.
 */

import { Navigate } from "react-router-dom";
import { isTokenValid } from "../Auth/Auth";

export default function ProtectedRoute({ children }) {
    console.log("ProtectedRoute → token valid?", isTokenValid());
    //Temp comment 20260318
    //if (!isTokenValid()) {
    //    console.log("Redirecting to login...");
    //    return <Navigate to="/login" replace />;
    //}

    console.log("Access allowed");
    return children;
}
